module.exports = __webpack_public_path__ + "img/IR.901ceaf1.svg";